import { Typography } from '@mui/material';
import * as React from 'react';

export const FieldVisibilitiesPage: React.FunctionComponent = () => {
    return <Typography>FieldVisibilities page: Work in progress</Typography>;
};
